"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ICON_MAPPING = void 0;
const react_1 = __importDefault(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const icons_1 = require("../../../icons");
exports.ICON_MAPPING = {
    error: react_1.default.createElement(icons_1.WarningIcon, { fill: ui_components_1.baseColors.red400 }),
    success: react_1.default.createElement(ui_components_1.Icon, { variant: "check", color: ui_components_1.baseColors.primaryBlue200 }),
};
